import selectOptions from '@/assets/json/selectOptions.json';

export default {
  props: ['preflist', 'options', 'update', 'searchText'],
  async mounted() {
    this.location = this.storedLocation;
    this.isCityListReady = false;

    // default our select values appropriately if our location data does not contain property hits
    const prefCode = this.location.pref.code;
    const containsPropertyHits = !!this.preflist.find(p => p.pref_code === prefCode);
    if (!containsPropertyHits) {
      this.options.prefcode = 0;
      this.options.citycode = 0;
      return;
    }
    this.options.prefcode = prefCode;

    const cityCode = this.location.city.code;
    this.citylist = await this.getCityList(1, this.options.prefcode, 0);
    const cityContainsPropertyHits = !!this.citylist.find(c => c.city_code === cityCode);
    this.options.citycode = cityContainsPropertyHits ? this.location.city.code : 0;

    this.isCityListReady = true;
    this.layout = this.options.layout;
  },
  computed: {
    storedLocation() {
      return this.$store.getters['getLocation'];
    },
    buttonText() {
      return this.searchText || '更新';
    },
  },
  watch: {
    layout() {
      // checkboxをObj内Arrayと直接Bindできなかったため一旦外だしする
      this.options.layout = this.layout;
    },
  },
  created() {
    this.optionList = selectOptions;
  },
  data() {
    return {
      citylist: [],
      optionList: {},
      layout: [], // watcher用
      isCityListReady: false,
      isDisplayPrice: false,
      isDisplayLayout: false,
      isDisplayLand: false,
      isDisplayBuilding: false,
      isDisplayWalk: false,
      isChanged: false,
    };
  },
  methods: {
    onClickToggleModal(flag) {
      if (flag !== 0) this.isDisplayPrice = false;
      else this.isDisplayPrice = !this.isDisplayPrice;
      if (flag !== 1) this.isDisplayLayout = false;
      else this.isDisplayLayout = !this.isDisplayLayout;
      if (flag !== 2) this.isDisplayLand = false;
      else this.isDisplayLand = !this.isDisplayLand;
      if (flag !== 3) this.isDisplayBuilding = false;
      else this.isDisplayBuilding = !this.isDisplayBuilding;
      if (flag !== 4) this.isDisplayWalk = false;
      else this.isDisplayWalk = !this.isDisplayWalk;
    },
    async onChangeCityList() {
      this.options.citycode = 0;
      this.isCityListReady = false;
      this.citylist = await this.getCityList(1, this.options.prefcode, 0);
      this.options.citycode = 0;
      this.isCityListReady = true;
    },
  },
};
